import { render, staticRenderFns } from "./HistoryOrder.vue?vue&type=template&id=b2c0a9e0&scoped=true&lang=pug&"
import script from "./HistoryOrder.vue?vue&type=script&lang=js&"
export * from "./HistoryOrder.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOrder.vue?vue&type=style&index=0&id=b2c0a9e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c0a9e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VExpandTransition,VRow})
